module.exports = __webpack_public_path__ + "img/gloves.12423186.png";